// Mirrors the backend normalization: the Saxo registration suffix and casing
// are ignored ("AI:xpar" == "AI_REGD:XPAR"), the exchange is kept.
export const exclusionKey = (symbol) => {
  const s = (symbol || '').trim();
  const i = s.indexOf(':');
  const ticker = i >= 0 ? s.slice(0, i) : s;
  const mic = i >= 0 ? s.slice(i + 1) : '';
  return `${ticker.split('_')[0].toUpperCase()}:${mic.toUpperCase()}`;
};
